import Api from '@/api';
import State from './state';

const loadServices = (context, companyId) => {
  context.commit('setError', null);
  context.commit('setLoading', true);

  return Api.inspectionServicesService
    .getCompanyPublicServices(companyId)
    .then(res => context.commit('setRecords', res.data))
    .catch(err => context.commit('setError', err))
    .finally(() => context.commit('setLoading', false));
};

const resetServices = context => {
  context.commit('setRecords', State.records);
};

export default {
  loadServices,
  resetServices,
};
